// ts-gql-integrity:a91e526cd1e356e7976e4616fb81253d
/*
ts-gql-meta-begin
{
  "hash": "38f5dfad6917c21f2f6925f5b3a61879"
}
ts-gql-meta-end
*/

import * as SchemaTypes from "./@schema";
import { TypedDocumentNode } from "@ts-gql/tag";

type UpdateTenantUserManagerMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.TenantUserManagerInput;
}>;


type UpdateTenantUserManagerMutation = { readonly __typename: 'Mutation', readonly updateTenantUserManager: boolean | null };



export type type = TypedDocumentNode<{
  type: "mutation";
  result: UpdateTenantUserManagerMutation;
  variables: UpdateTenantUserManagerMutationVariables;
  documents: SchemaTypes.TSGQLDocuments;
  fragments: SchemaTypes.TSGQLRequiredFragments<"none">
}>

declare module "./@schema" {
  interface TSGQLDocuments {
    UpdateTenantUserManager: type;
  }
}

export const document = JSON.parse("{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"mutation\",\"name\":{\"kind\":\"Name\",\"value\":\"UpdateTenantUserManager\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"input\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"TenantUserManagerInput\"}}},\"directives\":[]}],\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"updateTenantUserManager\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"input\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"input\"}}}],\"directives\":[]}]}}]}")
